import { z } from 'zod';

export const visionAIGenerateSchema = z.object({
  future_aspiration: z
    .string()
    .min(20, 'Future aspiration must be at least 20 characters')
    .optional()
    .or(z.literal('')),
  target_achievement: z
    .string()
    .min(15, 'Target achievement must be at least 15 characters')
    .optional()
    .or(z.literal('')),
  desired_impact: z.string().min(20, 'Desired impact must be at least 20 characters').optional().or(z.literal('')),
  timeline: z.string().regex(/^\d+$/, 'Timeline must be a number (in years)').optional().or(z.literal('')),
});

export type VisionAIGenerateFormData = z.infer<typeof visionAIGenerateSchema>;
